module.exports = __webpack_public_path__ + "img/182.0ff81823.jpg";